import { gql } from "@grandvisionhq/graphql";
import { checkoutMutationResult } from "../../../fragments/operations/fragments/checkout-mutation-result.js";
import { unknownUpdateCartFailure } from "../../../fragments/operations/fragments/cart-mutation-failures.js";
const SET_SERVICE_STORE = gql`
  mutation SetServiceStore($storeInput: CheckoutServiceStoreInput!) {
    setServiceStore(storeInput: $storeInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;
export {
  SET_SERVICE_STORE
};
//# sourceMappingURL=set-service-store.js.map
